// @ts-strict-ignore
import { DrillingHoleInfo } from '@3d-scene/model3d/util/drillinghole/drilling-hole-info';

export class ParseProServeData {
    public productionConnection?: string[];
    public articlesForOneProject?: string[];
    public mappingArticleNo?: string[];
    public xmltoArray?: string[];
    public tagsByProjectArticleId?: string[];
    public productionConnectionWithSameArticleID?: string[];
    public holes?: DrillingHoleInfo[];
    public _labelAttribute?: string[];
    public constructor(productionConnection, articlesForOneProject, mappingArticleNo, xmltoArray,
         tagsByProjectArticleId, productionConnectionWithSameArticleID, holes, _labelAttribute) {
             this.articlesForOneProject = articlesForOneProject;
             this.holes = holes;
             this.mappingArticleNo = mappingArticleNo;
             this.productionConnection = productionConnection;
             this.productionConnectionWithSameArticleID = productionConnectionWithSameArticleID;
             this.tagsByProjectArticleId = tagsByProjectArticleId;
             this.xmltoArray = xmltoArray;
             this._labelAttribute = _labelAttribute;
         }
}
